import { useEffect, useRef, useState } from 'react';
import { api } from '@/lib/api';
import type { SavedFlightStatusResponse } from '@/types/api';

export function useSavedFlightStatus(id: number | null) {
  const [status, setStatus] = useState<SavedFlightStatusResponse | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (id == null) return;
    let cancelled = false;

    async function poll() {
      try {
        const res = await api.get<SavedFlightStatusResponse>(`/flights/saved/${id}/status`);
        if (cancelled) return;
        setStatus(res);
        if (res.pollAfterSeconds) {
          timerRef.current = setTimeout(poll, res.pollAfterSeconds * 1000);
        }
      } catch {
        if (!cancelled) timerRef.current = setTimeout(poll, 10 * 60 * 1000);
      }
    }

    poll();
    return () => {
      cancelled = true;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [id]);

  return status;
}
